import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {isTopLevelDataFrameView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanReplaceStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {recordAnalysisAction} from 'analysis-tool/ui/debugAnalysisActionHistory';
import {AnalysisMainViewItem, AnalysisMainViewItemType} from 'analysis-tool/ui/main-view/MainViewTypes';
import {getLegacyStepFromAnalysis} from 'pipelines/StepUtil';

export default function getReplaceSourceAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void
): OverflowDataViewAction | null {
  if (!isTopLevelDataFrameView(view) || isAnalysisReadOnly(analysis)) {
    return null;
  }

  const stepToReplace = getLegacyStepFromAnalysis(analysis, view.lineage[0].step);
  const {canEdit, message} = checkCanReplaceStep(analysis, stepToReplace);

  return {
    icon: 'arrow-right-arrow-left',
    onClick: () => {
      recordAnalysisAction('REPLACE_SOURCE', {
        analysisId: analysis.id,
        stepIdToReplace: stepToReplace.id,
        stepTypeToReplace: stepToReplace.definition.stepType,
      });
      onChangeSelectedItem({
        type: AnalysisMainViewItemType.CHOOSE_DATASET_CREATION_METHOD,
        stepIdToReplace: stepToReplace.id,
      });
    },
    label: 'Replace source',
    isDisabled: !canEdit,
    helpText: !canEdit ? message : undefined,
  };
}
